var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.appLoaded)?_c('div',{staticClass:"master page"},[_c('MessageBar',{attrs:{"name":"default"}}),_c('PageHeader'),_c('PageView'),(!_vm.hideFooter)?_c('PageFooter'):_vm._e(),_c('PopupWrapper',{attrs:{"name":"default"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }